<template lang="pug">

  .password-reset-component
    .password-reset-header(v-if="header") {{ header }}
    form(@submit.prevent='reset', @keydown='form.onKeydown($event)', :class="{ 'has-errors': form.errors.any() }")
      form-group-row(:form="form", name="email", :label="emailLabel || $t('password_reset.email')")
        form-input(:form="form", name="email", type="email", :placeholder="noPlaceholders ? '' : (emailPlaceholder || $t('password_reset.email_placeholder'))")
      form-group-row(:form="form", name="password", :label="passwordLabel || $t('password_reset.password')")
        form-input(:form="form", name="password", type="password", :placeholder="noPlaceholders ? '' : (passwordPlaceholder || $t('password_reset.password_placeholder'))")
      form-group-row(:form="form", name="password_confirmation", :label="passwordConfirmationLabel || $t('password_reset.password_confirmation')")
        form-input(:form="form", name="password_confirmation", type="password", :placeholder="noPlaceholders ? '' : (passwordConfirmationPlaceholder || $t('password_reset.password_confirmation_placeholder'))")
      .form-group.no-check
        v-button.btn-default(:class="submitClass" :loading="form.busy", block) {{ submitLabel || $t('password_reset.submit') }}

    form-success-modal(:form="form" v-if="!noSuccessModal")
      template(slot="title") Success!
      template(slot="message") {{ status }}
      template(slot="buttons")
        router-link.btn.btn-primary(:to="{ name: 'sign-in' }") Sign in
      
</template>

<script>
import Form from 'vform'
const EventBus = window.VueEventBus

export default {
  name: 'password-reset',

  props: [
    'email',
    'token',
    'submitLabel',
    'header',
    'submitClass',
    'emailLabel',
    'passwordLabel',
    'passwordConfirmationLabel',
    'noPlaceholders',
    'emailPlaceholder',
    'passwordPlaceholder',
    'passwordConfirmationPlaceholder',
    'noSuccessModal'
  ],

  data: () => ({
    status: '',
    form: new Form({
      token: '',
      email: '',
      password: '',
      password_confirmation: ''
    })
  }),
  created() {
    if (this.email) {
      this.form.email = this.email
    }
  },
  methods: {
    async reset () {
      this.form.token = this.token;

      EventBus.$emit('password-reset.init', this.form.email)

      try {
        const { data } = await this.form.post(`${window.addiesaas.url}/api/user/password/reset`)
        this.status = data.status
        EventBus.$emit('password-reset.success', this.form.email, data.status)
        this.form.reset()
      } catch (e) {
        this.status = '';
        EventBus.$emit('password-reset.failed', e, this.form.email)
      }

      EventBus.$emit('password-reset.end', this.form.email)


    }
  }
}
</script>
